module.exports = __webpack_public_path__ + "static/img/img_solution_23.449815e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/msolution/img_solution_23.png
// module id = C2Lg
// module chunks = 0